<template>
  <span>
    <span v-if="type === ContentType.TEXT">
      {{ content.text }}
    </span>
    <span v-else-if="type === ContentType.MEDIA">
      <em>See attachments</em>
    </span>
    <span v-else-if="type === ContentType.INLINE_CARD">
      <SoLink :text="attrs.url" :href="attrs.url" />
    </span>
    <SoMention v-else-if="type === ContentType.MENTION">
      {{ attrs.text }}
    </SoMention>
    <span v-else-if="type === ContentType.HARD_BREAK">
      <br />
    </span>
    <span v-else-if="type === ContentType.HEADING">
      <strong>
        {{ content.text }}
      </strong>
    </span>
    <span v-else-if="type === ContentType.LIST_ITEM">
      <JiraCommentContentList :content="content.content" />
    </span>
    <span v-else>
      {{ content }}
    </span>
  </span>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoLink from "@/components/SoLink.vue"
  import JiraCommentContentList from "@/views/customer/issues/components/JiraCommentContentList.vue"
  import {
    AttrsType,
    ContentType,
    ContentWithinInnerType,
  } from "@/models/jiraIssue/jiraIssue.types"
  import SoMention from "@/components/SoMention.vue"

  export default defineComponent({
    components: { SoMention, JiraCommentContentList, SoLink },
    props: {
      type: {
        type: String as PropType<ContentType>,
        required: true,
      },
      attrs: {
        type: Object as PropType<AttrsType>,
        default: {} as AttrsType,
      },
      content: {
        type: Object as PropType<ContentWithinInnerType>,
        default: {} as ContentWithinInnerType,
      },
    },
    computed: {
      ContentType() {
        return ContentType
      },
    },
  })
</script>
